<template>
  <div class="wrapper">
    <div class="status">
      <span>{{status_name}}</span>
      <span>{{refund_name}}</span>
    </div>
    <!-- <div class="time">退款成功时间：2019-01-09 10:59:37</div> -->
    <div class="total">
      退款总金额：
      <span class="price">￥{{info.refund}}</span>
    </div>
    <div class="detail">
      <h3 class="d-title">申请服务详情</h3>
      <div class="d-item shop" v-show="info.items&&info.items.length>0">
        <div class="shop-img" v-for="(item,index) in info.items" :key="index">
          <img v-lazy="item.image_url" :alt="item.name">
          <!-- <span class="shop-name">{{item.name}}</span> -->
        </div>
      </div>
      <div class="d-item">
        <span class="label">订单编号</span>:
        <span class="text">{{info.order_id}}</span>
      </div>
      <div class="d-item">
        <span class="label">退款金额</span>:
        <span class="text">￥{{info.refund}}</span>
      </div>
      <div class="d-item">
        <span class="label">要求</span>:
        <span class="text">{{info.type==1?'仅退款':'退款退货'}}</span>
      </div>
      <div class="d-item">
        <span class="label">说明</span>:
        <span class="text">{{info.reason||'无任何说明'}}</span>
      </div>
      <div class="d-item img-wrap">
        <span class="label">图片</span>:
        <span class="text">
          <img v-for="item in info.images" :key="item.image_id" v-lazy="item.url" alt="" width="100px">
        </span>
      </div>
    </div>
    <div v-if="info.status==2">
      <h3 class="d-title">退货邮寄地址信息</h3>
      <div class="reship">
        <div class="reship-item">
          <div class="label">收件人:</div>
          <div class="text">{{reship.reship_name}}</div>
        </div>
        <div class="reship-item">
          <div class="label">联系方式:</div>
          <div class="text">{{reship.reship_mobile}}</div>
        </div>
        <div class="reship-item">
          <div class="label">邮寄地址:</div>
          <div class="text">{{reship.reship_area+reship.reship_address}}</div>
        </div>
      </div>
      <div class="ship-form">
        <el-form label-position="right" label-width="80px" :model="formLabelAlign">
          <el-form-item label="快递公司">
            <el-input
              v-model="formLabelAlign.logistics"
              placeholder="请输入快递公司名称"
              :disabled="info.status === 2 && reshipStatus > 1"
            ></el-input>
          </el-form-item>
          <el-form-item label="快递单号">
            <el-input
              v-model="formLabelAlign.logisticsCode"
              placeholder="请输入快递单号"
              :disabled="info.status === 2 && reshipStatus > 1"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="send" v-if="info.status==2&&reshipStatus==1" @click="submit">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RefundDetail",
  components: {},
  props: {},
  data() {
    return {
      info: {},
      aftersales_id: "",
      status_name: "审核中", //售后单状态文字描述
      refund_name: "", //退款单状态描述
      reshipStatus: "", // 退货单状态
      reshipName: "", //退货单状态描述
      reship_id: "", //退货单号
      formLabelAlign: {
        logistics: "", // 快递公司
        logisticsCode: "" // 快递单号
      },
      reship: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    submit() {
      if (!this.formLabelAlign.logistics) {
        return this.$msg("请填写快递公司名称", "warning");
      }
      if (!this.formLabelAlign.logisticsCode) {
        return this.$msg("请填写快递单号", "warning");
      }
      let data = {
        reship_id: this.reship_id,
        logi_code: this.formLabelAlign.logistics,
        logi_no: this.formLabelAlign.logisticsCode
      };
      this.$api.sendShip(data).then(res => {
        if (res.status) {
          this.getAfterSaleInfo();
        }
      });
    },
    getAfterSaleInfo() {
      let data = {
        aftersales_id: this.aftersales_id
      };
      this.$api.afterSalesInfo(data).then(res => {
        if (res.status) {
          let info = res.data.info;
          this.info = info;
          this.reship = res.data.reship;
          if (info.status == 1) {
            this.status_name = "审核中";
          } else if (info.status == 2) {
            this.status_name = "申请通过";
            if (info.bill_refund) {
              if (info.bill_refund.status == 1) {
                this.refund_name = "退款中";
              } else if (info.bill_refund.status == 2) {
                this.refund_name = "退款成功";
              } else if (info.bill_refund.status === 3) {
                this.refund_name = "退款失败";
              } else if (info.bill_refund.status === 4) {
                this.refund_name = "退款拒绝";
              }
            }
            //退货单状态
            if (info.bill_reship) {
              this.reship_id = info.bill_reship.reship_id;
              if (info.bill_reship.status === 1) {
                this.reshipStatus = 1;
                this.reshipName = "待发退货";
              } else if (info.bill_reship.status === 2) {
                this.reshipStatus = 2;
                this.reshipName = "待收退货";
                this.formLabelAlign.logistics = info.bill_reship.logi_code;
                this.formLabelAlign.logisticsCode = info.bill_reship.logi_no;
              } else {
                this.reshipStatus = 3;
                this.reshipName = "已收退货";
                this.formLabelAlign.logistics = info.bill_reship.logi_code;
                this.formLabelAlign.logisticsCode = info.bill_reship.logi_no;
              }
            }
          } else {
            this.status_name = "申请驳回";
          }
        }
      });
    }
  },
  created() {},
  mounted() {
    let aftersales_id = this.$route.params.aftersales_id;
    this.aftersales_id = aftersales_id;
    this.getAfterSaleInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .send {
    width: 150px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: $theme-color;
    color: #fff;
    margin: 0 auto;
    cursor: pointer;
  }
  .detail {
    .d-item {
      margin-bottom: 20px;
      position: relative;
      &.img-wrap {
        display: flex;
        .label {
          flex: 0 0 60px;
        }
      }
      &.shop {
        border-bottom: 1px solid $border;
        padding: 20px 0;
        display: flex;
        .shop-img {
          width: 60px;
          height: 60px;
          border: 1px solid $border;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
      .shop-name {
        display: block;
        height: 60px;
        margin-left: 80px;
      }
      .label {
        display: inline-block;
        width: 60px;
        text-align-last: justify;
        color: #757575;
      }
      .text {
        display: inline-block;
        margin-left: 20px;
      }
    }
  }
  .d-title {
    margin: 20px 0;
    height: 30px;
    line-height: 30px;
    background: $theme-bg;
    padding-left: 10px;
  }
  .reship {
    .reship-item {
      display: flex;
      align-items: center;
      height: 40px;
      margin-bottom: 10px;
      .label {
        display: block;
        width: 80px;
        text-align: right;
        font-size: 14px;
        color: #606266;
        padding-right: 12px;
        box-sizing: border-box;
      }
    }
  }
  .ship-form {
    width: 300px;
  }

  .status {
    font-weight: bold;
    line-height: 30px;
    font-size: 18px;
    margin-bottom: 10px;
    span {
      margin-right: 20px;
    }
  }
  .time {
    color: #757575;
  }
  .total {
    margin-top: 15px;
    padding-bottom: 20px;
    border-bottom: 1px solid $border;
    .price {
      color: $theme-color;
      font-size: 16px;
    }
  }
}
</style>